import { v4 as uuidv4 } from "uuid";
import { localStore } from "./storage.service";




export const getVisiorData = () => {
  let visitorData = localStore.getItem("rfVisitorData");
  if (!visitorData) {
    let visitorId = uuidv4();
    visitorData = JSON.stringify({ visitorId: visitorId });
    localStore.setItem("rfVisitorData", visitorData);
  }
  return JSON.parse(visitorData);
};
